class SybilRoutineSelector extends HTMLElement {
  #controller;
  #persistentIndex = null;
  #claims = [];
  #products = [];

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.#claims = [...this.querySelectorAll('[data-sybil-routine-claim]')];
    this.#products = [...this.querySelectorAll('[data-sybil-routine-product]')];
    const options = { signal: this.#controller.signal };

    for (const claim of this.#claims) {
      const index = Number(claim.dataset.sybilRoutineClaim);
      claim.addEventListener('pointerenter', () => this.#apply(index), options);
      claim.addEventListener('pointerleave', () => this.#restore(), options);
      claim.addEventListener('focus', () => this.#apply(index), options);
      claim.addEventListener('blur', () => this.#restore(), options);
      claim.addEventListener('click', () => {
        this.#persistentIndex = index;
        this.#apply(index);
      }, options);
      claim.addEventListener('keydown', (event) => this.#handleKeydown(event), options);
    }

    for (const product of this.#products) {
      const index = Number(product.dataset.sybilRoutineProduct);
      product.addEventListener('pointerenter', () => this.#apply(index), options);
      product.addEventListener('pointerleave', () => this.#restore(), options);
      product.addEventListener('focus', () => this.#apply(index), options);
      product.addEventListener('blur', () => this.#restore(), options);
    }

    this.#restore();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #handleKeydown(event) {
    const currentIndex = this.#claims.indexOf(event.currentTarget);
    let nextIndex;

    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (currentIndex - 1 + this.#claims.length) % this.#claims.length;
    } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (currentIndex + 1) % this.#claims.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.#claims.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    this.#claims[nextIndex].focus();
  }

  #restore() {
    this.#apply(this.#persistentIndex);
  }

  #apply(activeIndex) {
    for (const claim of this.#claims) {
      const selected = Number(claim.dataset.sybilRoutineClaim) === activeIndex;
      claim.setAttribute('aria-pressed', String(selected));
    }

    for (const product of this.#products) {
      const active = Number(product.dataset.sybilRoutineProduct) === activeIndex;
      product.classList.toggle('is-active', active);
      product.classList.toggle('is-dimmed', activeIndex != null && !active);
    }
  }
}

if (!customElements.get('sybil-routine-selector')) {
  customElements.define('sybil-routine-selector', SybilRoutineSelector);
}
